export default __webpack_public_path__ + "static/media/icon-close-inv.add8a9cf.svg";